import { render, staticRenderFns } from "./CRadio.vue?vue&type=template&id=0984365c&scoped=true"
import script from "./CRadio.vue?vue&type=script&setup=true&lang=ts"
export * from "./CRadio.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CRadio.vue?vue&type=style&index=0&id=0984365c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0984365c",
  null
  
)

export default component.exports